import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { LocationTypes } from '~src/ts/models/ILocationInfo';

import { BasicField } from './BasicField';
import { EntityLinkProps } from './EntityLink';
import { RelatedEntity } from './RelatedEntity';

export interface LocationFieldProps {
  locationType: LocationTypes;
  inProjectSpace: boolean;
  inPersonalSpace: boolean;
  personalSpaceLink: EntityLinkProps;
  contentOwnerId: string;
  projectLink?: EntityLinkProps;
}

export function LocationField(props: LocationFieldProps) {
  const currentUserId = getSessionManagementServiceInstance().sessionUserId();
  const isOwner = currentUserId === props.contentOwnerId;
  return (
  <>
    {!props.inPersonalSpace && props.locationType === LocationTypes.PersonalSpace && isOwner &&
    <RelatedEntity label={Messages.column_location()} link={props.personalSpaceLink}/> }
    {!props.inPersonalSpace && props.locationType === LocationTypes.PersonalSpace && !isOwner &&
    <BasicField name={Messages.column_location()} value={Messages.personalSpaceGridLabel()}/> }
    {!props.inProjectSpace && props.locationType === LocationTypes.Project &&
    <RelatedEntity label={Messages.column_location()} link={props.projectLink} /> }
  </>
  );
}
